<template>
    <div>
        <div>
            <img src="../../../assets/mk体育(中国)官方网站 - mk sports/product/info/sensor/12.png" style="width: 100%" alt="">
        </div>
        <div class="info-father">
            <div class="index-div-content  product-info-div-no-padding">
                <div>
                    <h3 class="margin-bottom-10 center color-1B1B1B font-28 ">
                        <img src="../../../assets/img/1.png" width="31" alt="">
                        <span style="margin:0 20px">功能特点</span>
                        <img src="../../../assets/img/2.png" width="31" alt="">
                    </h3>
                </div>
                <div class="product_info">
                    <div><img src="../../../assets/mk体育(中国)官方网站 - mk sports/product/info/sensor/11.png" width="140" alt=""></div>
                    <div><img src="../../../assets/mk体育(中国)官方网站 - mk sports/product/info/sensor/10.png" width="140" alt=""></div>
                    <div><img src="../../../assets/mk体育(中国)官方网站 - mk sports/product/info/sensor/9.png" width="140" alt=""></div>
                    <div><img src="../../../assets/mk体育(中国)官方网站 - mk sports/product/info/sensor/8.png" width="140" alt=""></div>
                    <div><img src="../../../assets/mk体育(中国)官方网站 - mk sports/product/info/sensor/7.png" width="140" alt=""></div>
                </div>
            </div>
        </div>
        <div class=" margin-top-20">
            <div >
                <div class="index-div-content  product-info-div-no-padding padding-20-computer background-white  ">

                    <h3 class="margin-bottom-20 center color-1B1B1B font-28 ">
                        <img src="../../../assets/img/1.png" width="31" alt="">
                        <span style="margin:0 20px">产品参数</span>
                        <img src="../../../assets/img/2.png" width="31" alt="">
                    </h3>
                    <div class="center">
                        <img src="../../../assets/mk体育(中国)官方网站 - mk sports/product/info/sensor/13.png" style="width:100%" alt="">
                    </div>
                </div>
            </div>

        </div>
        <div class=" margin-top-20">
            <div >
                <div class="index-div-content  product-info-div-no-padding padding-20-computer background-white  ">

                    <h3 class="margin-bottom-20 center color-1B1B1B font-28 ">
                        <img src="../../../assets/img/1.png" width="31" alt="">
                        <span style="margin:0 20px">应用场景</span>
                        <img src="../../../assets/img/2.png" width="31" alt="">
                    </h3>
                    <div class="center">
                        <div class="product_info">
                            <div class="sensor-div">
                                <img src="../../../assets/mk体育(中国)官方网站 - mk sports/product/info/sensor/1.png" width="140" alt="">
                                <p class="margin-top-20 center color-1B1B1B bolder">煤矿场景</p>
                            </div>
                            <div class="sensor-div"><img src="../../../assets/mk体育(中国)官方网站 - mk sports/product/info/sensor/2.png" width="140" alt="">   <p class="margin-top-20 center color-1B1B1B bolder">钢铁厂场景</p></div>
                            <div class="sensor-div"><img src="../../../assets/mk体育(中国)官方网站 - mk sports/product/info/sensor/3.png" width="140" alt="">   <p class="margin-top-20 center color-1B1B1B bolder">水泥厂场景</p></div>
                            <div class="sensor-div"><img src="../../../assets/mk体育(中国)官方网站 - mk sports/product/info/sensor/4.png" width="140" alt="">   <p class="margin-top-20 center color-1B1B1B bolder">电力场景</p></div>
                            <div class="sensor-div"><img src="../../../assets/mk体育(中国)官方网站 - mk sports/product/info/sensor/5.png" width="140" alt="">   <p class="margin-top-20 center color-1B1B1B bolder">港口场景</p></div>
                            <div class="sensor-div"><img src="../../../assets/mk体育(中国)官方网站 - mk sports/product/info/sensor/6.png" width="140" alt="">   <p class="margin-top-20 center color-1B1B1B bolder">化工厂场景</p></div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="background-white margin-top-20">
            <div >
                <div class="index-div-content  product-info-div-no-padding   ">

                    <h3 class="margin-bottom-10 center color-1B1B1B font-28 ">
                        <img src="../../../assets/img/1.png" width="31" alt=""> <span style="margin:0 20px">应用案例</span>
                        <img
                                src="../../../assets/img/2.png" width="31" alt="">
                    </h3>
                    <div>
                        <el-row :gutter="20">
                            <el-col :xs="24" :sm="12">
                                <div>
                                    <video-component video-url="https://mk体育(中国)官方网站 - mk sports-video.oss-cn-beijing.aliyuncs.com/video/01-%E6%A0%87%E5%87%86Ladybug-%E9%95%BF%E9%80%94%E8%BE%93%E9%80%81%E5%B8%A6-%E7%BA%A6%E5%9F%BA-%E5%B1%B1%E8%A5%BF%E6%96%87%E6%B0%B4.mp4"/>
                                    <div class="video-content">案例1：某不锈钢烟雾传感器现场检测</div>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12">
                                <div>
                                    <video-component1 video-url="https://mk体育(中国)官方网站 - mk sports-video.oss-cn-beijing.aliyuncs.com/video/03-%E6%A0%87%E5%87%86Ladybug-%E9%95%BF%E9%80%94%E8%BE%93%E9%80%81%E5%B8%A6-%E9%B2%81%E4%B8%9C%E5%A4%A7%E5%AD%A6-%E7%83%9F%E5%8F%B0%E8%A5%BF%E5%B2%97.mp4"/>
                                    <div class="video-content">案例2：某不锈钢烟雾传感器现场检测</div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div style="height: 20px">      </div>
                </div>
            </div>

        </div>

    </div>


</template>

<script>
    import VideoComponent from "../../commom/VideoComponent";
    import VideoComponent1 from "../../commom/VideoComponent";

    export default {
        name: "StainlessSteelSensor",
        components:{VideoComponent,VideoComponent1},
    }
</script>

<style scoped>

</style>